module.exports = __webpack_public_path__ + "img/DCS_0099-25-color-adjusted.14fc60f6.jpg";